const AUTH_PREFIX = '@@auth/';

export const AUTH_ACTION_TYPES = {
    OTP_REQUEST: `${AUTH_PREFIX}OTP_REQUEST`,
    OTP_SUCCESS: `${AUTH_PREFIX}OTP_SUCCESS`,
    OTP_FAILURE: `${AUTH_PREFIX}OTP_FAILURE`,

    LOGIN_OTP_REQUEST: `${AUTH_PREFIX}LOGIN_OTP_REQUEST`,
    LOGIN_OTP_SUCCESS: `${AUTH_PREFIX}LOGIN_OTP_SUCCESS`,
    LOGIN_OTP_FAILURE: `${AUTH_PREFIX}LOGIN_OTP_FAILURE`,

    SIGNUP_REQUEST: `${AUTH_PREFIX}SIGNUP_REQUEST`,
    SIGNUP_SUCCESS: `${AUTH_PREFIX}SIGNUP_SUCCESS`,
    SIGNUP_FAILURE: `${AUTH_PREFIX}SIGNUP_FAILURE`,

    FETCH_USER_REQUEST: `${AUTH_PREFIX}FETCH_USER_REQUEST`,
    FETCH_USER_SUCCESS: `${AUTH_PREFIX}FETCH_USER_SUCCESS`,
    FETCH_USER_FAILURE: `${AUTH_PREFIX}FETCH_USER_FAILURE`,

    LOGOUT: `${AUTH_PREFIX}LOGOUT`,

    CLEAR_ERROR: `${AUTH_PREFIX}CLEAR_ERROR`,
};
